import { render, staticRenderFns } from "./learnList.vue?vue&type=template&id=8168f20c&scoped=true"
import script from "./learnList.vue?vue&type=script&lang=js"
export * from "./learnList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/learnList.scss?vue&type=style&index=0&id=8168f20c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8168f20c",
  null
  
)

export default component.exports